module.exports = __webpack_public_path__ + "static/fonts/TrebuchetMS.f2bb6f2.woff";